import { render, staticRenderFns } from "./complaints.vue?vue&type=template&id=c0a60620"
import script from "./complaints.ts?vue&type=script&lang=js&external"
export * from "./complaints.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports